import React from "react";
import logo from "../../img/logo-02.png";
import { Link } from "react-router-dom";
import { MyContext } from "../../context";
import { useState, useContext } from "react";

function ClientSidebar() {
  const { LinkSelection, updateLinkSelection, updateInstallationLinkSelection } = useContext(MyContext);
  const active = "sidebarListItem active";
  const notActive = "sidebarListItem ";

  const installation = ()=>{
    updateInstallationLinkSelection("Installation")
    updateLinkSelection("Clients")
  }

  return (
    <>
      <div className="sidebar">
        <div className="sidebarWrapper">
          <div className="sidebarMenu">
            <span className="sideLogo">
              <Link to="/home" className="">
                <img
                  src={logo}
                  className="logo"
                  style={{ margin: "0 auto", width: "70px" }}
                  alt="Login"
                />
              </Link>
            </span>

            <ul className="sidebarList">
              <span onClick={() => updateLinkSelection("")}>
                {" "}
                <li className={LinkSelection === "" ? active : notActive}>
                  <span class="material-symbols-rounded icon">dashboard</span>
                  <span>Overview</span>
                </li>
              </span>

              <span onClick={() => installation()}>
                {" "}
                <li
                  className={LinkSelection === "Clients" ? active : notActive}
                >
                  <span class="material-symbols-rounded icon">Person</span>
                  <span>My Installation</span>
                </li>
              </span>
              {/* 
              <span onClick={() => updateLinkSelection("Battery")}>
                <li
                  className={LinkSelection === "Battery" ? active : notActive}
                >
                  <span class="material-symbols-rounded icon">
                    battery_charging_20
                  </span>
                  <span>Battery</span>
                </li>
              </span>
              */}
              <span onClick={() => updateLinkSelection("Report")}>
                {" "}
              <li className={LinkSelection === "Report" ? active : notActive}>
                <span class="material-symbols-rounded icon">Report</span>
                <span>Report</span>
              </li>
              </span>

              <p className="dashboard_title sideTitle">Account</p>
              <hr />

              <span onClick={() => updateLinkSelection("Setting")}>
                {" "}
              <li className={LinkSelection === "Setting" ? active : notActive}>
                <span class="material-symbols-rounded icon">settings</span>
                <span>Setting</span>
              </li>
              </span>

            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

export default ClientSidebar;




